import {
  GET_CLAIM_CATEGORIES_START,
  GET_CLAIM_CATEGORIES_SUCCESS,
  GET_CLAIM_CATEGORIES_ERROR,
  GET_CLAIM_ACCOUNTS_START,
  GET_CLAIM_ACCOUNTS_SUCCESS,
  GET_CLAIM_ACCOUNTS_ERROR,
  GET_CLAIM_ITEM_START,
  GET_CLAIM_ITEM_SUCCESS,
  GET_CLAIM_ITEM_ERROR,
  SET_SELECTED_CLAIMANT,
  SET_SELECTED_PLAN_YEAR,
  CONVERT_HEIC_START,
  CONVERT_HEIC_SUCCESS,
  CONVERT_HEIC_ERROR,
  UPLOAD_CLAIM_RECEIPT_START,
  UPLOAD_CLAIM_RECEIPT_SUCCESS,
  UPLOAD_CLAIM_RECEIPT_ERROR,
  DELETE_CLAIM_RECEIPT_START,
  DELETE_CLAIM_RECEIPT_SUCCESS,
  DELETE_CLAIM_RECEIPT_ERROR,
  SET_SUPPORTING_DOCUMENTS_SUCCESS,
  REMOVE_SUPPORTING_DOCUMENT,
  SET_SUPPORTING_DOCUMENTS_ERROR,
  DELETE_CLAIM_REFERRAL_START,
  DELETE_CLAIM_REFERRAL_SUCCESS,
  DELETE_CLAIM_REFERRAL_ERROR,
  DELETE_CLAIM_DOCUMENT_START,
  DELETE_CLAIM_DOCUMENT_SUCCESS,
  DELETE_CLAIM_DOCUMENT_ERROR,
  GET_RECEIPT_OCR_START,
  GET_RECEIPT_OCR_SUCCESS,
  GET_RECEIPT_OCR_ERROR,
  SKIP_OCR,
  SET_REJECTED_RECEIPT,
  SET_REJECTED_SUPPORTING_DOCUMENTS,
  INCREMENT_OCR_REQUEST_COUNT,
  SAVE_CLAIM_DRAFT_SUCCESS,
  SAVE_CLAIM_DRAFT_ERROR,
  GET_CLAIM_NEED_HELP_START,
  GET_CLAIM_NEED_HELP_SUCCESS,
  GET_CLAIM_NEED_HELP_ERROR,
  POST_CLAIMS_NEED_HELP_SUCCESS,
  POST_CLAIMS_NEED_HELP_ERROR,
  GET_CLAIM_DOCUMENTS_START,
  GET_CLAIM_DOCUMENTS_SUCCESS,
  GET_CLAIM_DOCUMENTS_ERROR,
  SAVE_CLAIM_DOCUMENTS_START,
  SAVE_CLAIM_DOCUMENTS_SUCCESS,
  SAVE_CLAIM_DOCUMENTS_ERROR,
  SET_SELECTED_CLAIM_TYPE_ID,
  GET_CLAIM_DETAIL_START,
  GET_CLAIM_DETAIL_SUCCESS,
  CLEAR_GET_CLAIM_DETAIL,
  GET_CLAIM_DETAIL_ERROR,
  GET_CLAIMS_DASHBOARD_START,
  GET_CLAIMS_DASHBOARD_SUCCESS,
  GET_CLAIMS_DASHBOARD_ERROR,
  SET_SELECTED_QUESTION_TAG,
  SET_SELECTED_CATEGORY,
  SET_SELECTED_CLAIM,
  GET_DELEGATED_EMPLOYEES_START,
  GET_DELEGATED_EMPLOYEES_SUCCESS,
  GET_DELEGATED_EMPLOYEES_ERROR,
  SET_DELEGATED_EMPLOYEES,
  SET_DELEGATED_BY_EMPLOYEE_KEY,
  POST_DECISION_SUCCESS,
  GET_INSURER_CLAIM_CATEGORIES_START,
  GET_INSURER_CLAIM_CATEGORIES_SUCCESS,
  GET_INSURER_CLAIM_CATEGORIES_ERROR,
  SUBMIT_CLAIM_SUCCESS,
  SUBMIT_CLAIM_BEGIN,
  SUBMIT_CLAIM_ERROR,
  CLEAR_ERROR,
  GET_CAPTURED_PHOTO,
  CLEAR_CAPTURED_PHOTO,
  START_CAMERA_SUCESS,
  START_CAMERA_ERROR,
  GET_CURRENCY_EXCHANGE_RATES_START,
  GET_CURRENCY_EXCHANGE_RATES_SUCCESS,
  GET_CURRENCY_EXCHANGE_RATES_ERROR,
  SET_SELECTED_E_CARDS,
  GET_E_CARDS_START,
  GET_E_CARDS_SUCCESS,
  GET_CLINICS_START,
  GET_CLINICS_SUCCESS,
  GET_SEARCH_CLINICS_START,
  GET_SEARCH_CLINICS_SUCCESS,
  CHECK_CLAIM_REACH_LIMIT_START,
  CHECK_CLAIM_REACH_LIMIT_SUCCESS,
  CHECK_CLAIM_REACH_LIMIT_ERROR,
} from "actions/claimActionsPP";

const initialState = {
  planYears: [],
  claimants: [],
  delegatedEmployees: [],
  claimClassifications: [],
  claimAccounts: [],
  showClaimsAsList: false,
  claimItem: null,
  selectedClaimant: "",
  selectedPlanYear: "",
  selectedClaimTypeId: "",
  selectedClaimReachLimit: false,
  claimDetail: null,
  receipt: null,
  rejectedReceipt: null,
  ocrValues: null,
  documents: null,
  claimDashboard: null,
  disclaimer: "",
  isFetching: false,
  isCPFEnabled: true,
  isFetchingClaimAccounts: false,
  skipOCR: false,
  skipReceipt: false,
  ocrRequestCount: 0,
  error: null,
  needHelpQuestions: null,
  needHelpClaims: null,
  selectedQuestionTag: null,
  selectedCategory: null,
  selectedClaim: null,
  submittedClaim: null,
  capturedPhoto: null,
  isCameraStarted: false,
  supportingDocuments: [],
  convertingHeic: false,
  convertedJpeg: null,
  conversionError: null,
  currencyExchangeRates: [],
  selectedEcards: null,
  eCardsList: [],
  clinicsList: [],
  searchClinicsList: {},
  selectedDelegatedEmployeeKey: null
};

const skipReceipt = data => {
  if (data && Array.isArray(data.formFields)) {
    const receiptField = data.formFields.find(x => x.id === "Receipt");
    return !receiptField;
  }
  return false;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CLAIM_NEED_HELP_START:
    case UPLOAD_CLAIM_RECEIPT_START:
    case GET_CLAIMS_DASHBOARD_START:
    case SAVE_CLAIM_DOCUMENTS_START:
    case GET_DELEGATED_EMPLOYEES_START:
    case GET_INSURER_CLAIM_CATEGORIES_START:
    case CHECK_CLAIM_REACH_LIMIT_START:
    case GET_CURRENCY_EXCHANGE_RATES_START:
      return { ...state, isFetching: true };
    case GET_CLAIM_ACCOUNTS_START:
      return { ...state, isFetching: true, isFetchingClaimAccounts: true };
    case GET_CLAIM_CATEGORIES_START:
      return {
        ...state,
        claimants: [],
        claimClassifications: [],
        isFetching: true,
      };
    case GET_CLAIM_DETAIL_START:
      return {
        ...state,
        claimDetail: null,
        receipt: null,
        rejectedReceipt: null,
        ocrValues: null,
        isFetching: true,
      };
    case GET_CLAIM_CATEGORIES_SUCCESS:
      return {
        ...state,
        planYears: action.payload.planYears,
        selectedPlanYear: action.payload.planYears.find(x => x.isSelected).planID,
        claimants: action.payload.claimants,
        selectedClaimant:
          action.payload.claimants[0].type + "|" + action.payload.claimants[0].claimantKey,
        claimClassifications: action.payload.claimClassifications,
        showClaimsAsList: action.payload.showClaimsAsList,
        claimNotes: action.payload.claimNotes,
        disclaimer: action.payload.disclaimer,
        isCPFEnabled: action.payload.isCPFEnabled,
        isFetching: false,
        error: null,
      };
    case SET_SUPPORTING_DOCUMENTS_SUCCESS:
      return {
        ...state,
        supportingDocuments: [...state.supportingDocuments, action.payload],
      };
    case REMOVE_SUPPORTING_DOCUMENT:
      return {
        ...state,
        supportingDocuments: state.supportingDocuments.filter(doc => {
          return doc.preview !== action.payload;
        }),
      };
    case SET_SUPPORTING_DOCUMENTS_ERROR:
      return {
        ...state,
        supportingDocuments: null,
      };
    case GET_CAPTURED_PHOTO:
      return {
        ...state,
        capturedPhoto: action.payload,
      };
    case START_CAMERA_SUCESS:
      return {
        ...state,
        isCameraStarted: true,
      };
    case START_CAMERA_ERROR:
      return {
        ...state,
        isCameraStarted: false,
      };
    case GET_CLAIM_ACCOUNTS_SUCCESS:
      return {
        ...state,
        claimAccounts: action.payload,
        isFetching: false,
        isFetchingClaimAccounts: false,
        error: null,
      };
    case GET_CLAIM_ITEM_START:
      return {
        ...state,
        skipOCR: false,
        skipReceipt: false,
        receipt: null,
        ocrValues: null,
        isFetching: true,
      };
    case GET_CLAIM_ITEM_SUCCESS:
      return {
        ...state,
        receipt: null,
        ocrValues: null,
        rejectedReceipt: null,
        claimItem: action.payload,
        skipReceipt: skipReceipt(action.payload),
        selectedClaimTypeId: action.payload.claimTypeId,
        selectedPlanYear: action.payload.planYear.planID,
        isFetching: false,
        error: null,
      };
    case CHECK_CLAIM_REACH_LIMIT_SUCCESS:
      return {
        ...state,
        selectedClaimReachLimit: action.payload.reachLimit || false,
        isFetching: false,
        error: null,
      };
    case CHECK_CLAIM_REACH_LIMIT_ERROR:
      return {
        ...state,
        selectedClaimReachLimit: false, // default to false if error
        isFetching: false,
        error: action.payload,
      };
    case SET_SELECTED_CLAIMANT:
      return {
        ...state,
        selectedClaimant: action.payload,
        selectedCategory: null,
        selectedClaim: null,
      };
    case SET_SELECTED_PLAN_YEAR:
      return {
        ...state,
        selectedPlanYear: action.payload,
        selectedCategory: null,
        selectedClaim: null,
      };
    case SET_SELECTED_CLAIM_TYPE_ID:
      return {
        ...state,
        selectedClaimTypeId: action.payload,
      };
    case GET_CLAIM_DETAIL_SUCCESS:
      return {
        ...state,
        claimDetail: action.payload,
        selectedClaimant: action.payload.claimantName,
        isFetching: false,
      };
    case SUBMIT_CLAIM_SUCCESS:
      return {
        ...state,
        submittedClaim: action.payload,
      };
    case SUBMIT_CLAIM_ERROR:
      return {
        ...state,
        submittedClaim: null,
      };
    case CLEAR_GET_CLAIM_DETAIL:
      return {
        ...state,
        claimDetail: null,
      };
    case UPLOAD_CLAIM_RECEIPT_SUCCESS:
      return {
        ...state,
        receipt: { ...state.receipt, ...action.payload },
        rejectedReceipt: null,
        isFetching: false,
        error: null,
      };
    case DELETE_CLAIM_RECEIPT_START:
    case DELETE_CLAIM_REFERRAL_START:
    case DELETE_CLAIM_DOCUMENT_START:
      return { ...state, isFetching: true };
    case DELETE_CLAIM_RECEIPT_SUCCESS:
    case DELETE_CLAIM_REFERRAL_SUCCESS:
    case DELETE_CLAIM_DOCUMENT_SUCCESS:
      return {
        ...state,
        claimItem: {
          ...state.claimItem,
          formFields: state.claimItem.formFields.map(field => {
            const { color, ...rest } = field;
            return rest;
          }),
        },
        receipt: null,
        ocrValues: null,
        rejectedReceipt: null,
        claimDetail: null,
        isFetching: false,
        skipOCR: false,
        skipReceipt: false,
        ocrRequestCount: 0,
        error: null,
      };
    case GET_RECEIPT_OCR_START:
      return { ...state, ocrValues: null, isFetching: true };
    case GET_RECEIPT_OCR_SUCCESS:
      return {
        ...state,
        claimItem: {
          ...state.claimItem,
          formFields: state.claimItem.formFields.map(field => {
            const { color, ...rest } = field;
            return rest;
          }),
        },
        rejectedReceipt: null,
        ocrValues: action.payload,
        isFetching: false,
        skipOCR: false,
        skipReceipt: false,
        ocrRequestCount: 0,
        error: null,
      };
    case GET_RECEIPT_OCR_ERROR:
      return {
        ...state,
        isFetching: false,
        ocrValues: null,
        skipOCR: true,
        skipReceipt: false,
        ocrRequestCount: 0,
        error: action.payload,
      };
    case SKIP_OCR:
      return {
        ...state,
        skipOCR: true,
        skipReceipt: true,
        ocrValues: null,
        rejectedReceipt: null,
        ocrRequestCount: 0,
      };
    case SET_REJECTED_SUPPORTING_DOCUMENTS:
      return {
        ...state,
        rejectedSupportingFiles: action.payload,
      };
    case SET_REJECTED_RECEIPT:
      return {
        ...state,
        rejectedReceipt: action.payload,
        receipt: null,
        ocrValues: null,
        skipOCR: false,
        skipReceipt: false,
        ocrRequestCount: 0,
        isFetching: false,
      };
    case INCREMENT_OCR_REQUEST_COUNT:
      return {
        ...state,
        isFetching: false,
        ocrRequestCount: state.ocrRequestCount + 1,
      };
    case SAVE_CLAIM_DRAFT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        claimItem: null,
        documents: null,
        error: null,
      };
    case POST_CLAIMS_NEED_HELP_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        needHelpClaims: action.payload,
      };
    case POST_CLAIMS_NEED_HELP_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
        needHelpClaims: null,
      };
    case GET_CLAIM_NEED_HELP_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        needHelpQuestions: action.payload,
      };
    case GET_CLAIM_NEED_HELP_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
        needHelpQuestions: null,
      };
    case UPLOAD_CLAIM_RECEIPT_ERROR:
      return {
        ...state,
        receipt: null,
        ocrValues: null,
        isFetching: false,
        skipOCR: false,
        skipReceipt: false,
        ocrRequestCount: 0,
        error: action.payload,
      };
    case GET_CLAIM_DOCUMENTS_START:
      return {
        ...state,
        isFetching: false,
      };
    case GET_CLAIM_DOCUMENTS_SUCCESS:
      return {
        ...state,
        documents: action.payload,
        selectedClaimTypeId: action.payload.claimItemId,
        selectedPlanYear: action.payload.planYear,
        isFetching: false,
      };
    case GET_CLAIMS_DASHBOARD_SUCCESS:
      return {
        ...state,
        claimDashboard: { ...state.claimDashboard, ...action.payload },
        isFetching: false,
      };
    case GET_DELEGATED_EMPLOYEES_SUCCESS:
      return {
        ...state,
        delegatedEmployees: action.payload,
        isFetching: false,
      };
    case SET_DELEGATED_EMPLOYEES:
      return {
        ...state,
        employeeDelegated: action.payload,
      };
    case SET_DELEGATED_BY_EMPLOYEE_KEY:
      return {
        ...state,
        selectedDelegatedEmployeeKey: action.payload,
      };
    case POST_DECISION_SUCCESS:
      return {
        ...state,
        decision: action.payload,
      };
    case GET_INSURER_CLAIM_CATEGORIES_SUCCESS:
      return {
        ...state,
        claimDashboard: {
          ...(state.claimDashboard || {}),
          claimClassifications: action.payload.claimClassifications,
        },
        isFetching: false,
      };

    case SAVE_CLAIM_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
      };
    case GET_CURRENCY_EXCHANGE_RATES_SUCCESS:
      return {
        ...state,
        currencyExchangeRates: action.payload,
        isFetching: false,
        error: null,
      };
    case GET_CLAIM_CATEGORIES_ERROR:
    case GET_CLAIM_ITEM_ERROR:
    case DELETE_CLAIM_RECEIPT_ERROR:
    case DELETE_CLAIM_REFERRAL_ERROR:
    case DELETE_CLAIM_DOCUMENT_ERROR:
    case SAVE_CLAIM_DRAFT_ERROR:
    case GET_CLAIM_DOCUMENTS_ERROR:
    case GET_CLAIM_DETAIL_ERROR:
    case GET_CLAIMS_DASHBOARD_ERROR:
    case SAVE_CLAIM_DOCUMENTS_ERROR:
    case GET_DELEGATED_EMPLOYEES_ERROR:
    case GET_INSURER_CLAIM_CATEGORIES_ERROR:
    case GET_CURRENCY_EXCHANGE_RATES_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case GET_CLAIM_ACCOUNTS_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetchingClaimAccounts: false,
        error: action.payload,
      };
    case SET_SELECTED_QUESTION_TAG:
      return {
        ...state,
        selectedQuestionTag: action.payload,
      };
    case SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.payload,
      };
    case SET_SELECTED_CLAIM:
      return {
        ...state,
        selectedClaim: action.payload,
      };
    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case CONVERT_HEIC_START:
      return {
        ...state,
        convertingHeic: true,
        convertedJpeg: null,
        conversionError: null,
      };
    case CONVERT_HEIC_SUCCESS:
      return {
        ...state,
        convertingHeic: false,
        convertedJpeg: action.payload,
        conversionError: null,
      };

    case CONVERT_HEIC_ERROR:
      return {
        ...state,
        convertingHeic: false,
        convertedJpeg: null,
        conversionError: action.payload,
      };
    case SET_SELECTED_E_CARDS:
      return {
        ...state,
        selectedEcards: action.payload,
      };
    case GET_E_CARDS_START:
    case GET_CLINICS_START:
    case GET_SEARCH_CLINICS_START:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case GET_E_CARDS_SUCCESS:
      return {
        ...state,
        eCardsList: action.payload,
        isFetching: false,
        error: null,
      };
    case GET_CLINICS_SUCCESS:
      return {
        ...state,
        clinicsList: action.payload,
        isFetching: false,
        error: null,
      };
    case GET_SEARCH_CLINICS_SUCCESS:
      return {
        ...state,
        searchClinicsList: action.payload,
        isFetching: false,
        error: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/claimsReducerPP.js